
import React, { Fragment } from 'react';
import PageTitle from '../../components/pagetitle/PageTitle';
import Header from '../../components/header/Header';
import Scrollbar from '../../components/scrollbar/scrollbar'
import Footer from '../../components/footer/Footer';
import CustomerRulesAndregulations from '../../components/CustomerRulesAndRegulations/CustomerRulesAndRegulations';


const CustomerRulesAndRegulations = (props) => {

    return (
        <Fragment>
            <div className='index_ico page_wrapper'>
                <Header />
                <main className="page_content">
                    <PageTitle pageTitle={'Customer Rules And Regulations'} pagesub={'Home'} />
                    <CustomerRulesAndregulations />
                </main>
                <Footer />
                <Scrollbar />
            </div>
        </Fragment>
    )
};
export default CustomerRulesAndRegulations;